import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import tw from "twin.macro";

import HomePage from "./Pages/HomePage";
import ContactUs from "./Pages/ContactUs";
import NavBar from "./Components/NavBar";
import Footer from "./Components/Footer";
import Projects from "./Pages/Projects";
import About from "./Pages/About";
import Services from "./Pages/Services";
import Insulation from "./Pages/Insulation";
import Drywall from "./Pages/Drywall";
import MudTape from "./Pages/MudTape";
import Paint from "./Pages/Paint";

const Container = tw.div`relative w-full `;
const ContentContainer = tw.div``;

export default function App() {
  return (
    <Container className="mainAppContainer">
      <NavBar />
      <ContentContainer className="contentWrap">
        <Router>
          <Routes>
            <Route exact path="/" element={<HomePage />} />
            <Route exact path="/About" element={<About />} />
            <Route exact path="/Services" element={<Services />} />
            <Route exact path="/Insulation" element={<Insulation />} />
            <Route exact path="/Drywall" element={<Drywall />} />
            <Route exact path="/MudTape" element={<MudTape />} />
            <Route exact path="/Paint" element={<Paint />} />
            <Route exact path="/Projects" element={<Projects />} />
            <Route exact path="/ContactUs" element={<ContactUs />} />
          </Routes>
        </Router>
      </ContentContainer>
      <Footer />
    </Container>
  );
}
